<template>
  <LayoutTelas
    id="tela__usuarios"
    :titulo="this.$route.meta.titulo"
    :isLoading="isLoading">
    <AlterarDadosUsuariosForm
      ref="formUsuario"
      :dados="dadosUsuario"
      @gravar="gravar" />

    <ModalConfirmacao
      ref="modalConfirmacao"
      titulo="Alteração de dados"
      mensagem="Confirmar as alterações dos dados?" />

  </LayoutTelas>
</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'
import AlterarDadosUsuariosForm from './AlterarDadosUsuariosForm.vue'
import UsuarioService from '../../../services/usuarios.service'
import GeradorMensagens from '@/mixins/GeradorMensagens'
import ModalConfirmacao from '@/components/modal/ModalConfirmacao.vue'

export default {
  name: 'AlterarDadosUsuarios',
  components: {
    AlterarDadosUsuariosForm,
    ModalConfirmacao,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      dadosUsuario: null,
      isLoading: false,
    }
  },
  beforeMount() {
    this.carregar()
  },
  methods: {
    ...mapActions('autenticacao', ['sairDoSistemaStore']),
    async gravar(dados) {
      const podeConcluir = await this.$refs.modalConfirmacao.pop()
      if (podeConcluir) {
        this.mostrarLoader()
        try {
          const retorno = await UsuarioService.atualizarPerfil(dados)
          this.tratarRespostaMsg(retorno)
          this.sairDoSistema()
        } catch (error) {
          this.tratarRespostaMsg(error)
        } finally {
          this.mostrarLoader(false)
        }
      }
    },
    async carregar() {
      this.mostrarLoader()
      try {
        const idUsuario = await this.$store.getters['autenticacao/userObj'].usuario._id
        const retorno = await UsuarioService.retornaPorId(idUsuario)

        this.dadosUsuario = _.pick(retorno, ['_id', 'email', 'nome', 'whatsapp'])
      } catch (error) {
        this.tratarRespostaMsg(error)
        this.$router.push({ name: 'rota-dashboard' })
      } finally {
        this.mostrarLoader(false)
      }
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
    sairDoSistema() {
      this.sairDoSistemaStore()
      location.reload()
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

#tela__usuarios {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}

</style>
